export default __webpack_public_path__ + "static/media/call_sound.8b58fc7a.wav";